
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageButton, IFlexMessageURIAction } from '@/utils/types'
import Offset from '@/components/common/flex-message/forms/Offset.vue'
import Action from '@/components/common/flex-message/forms/Action.vue'

@Options({
  components: { Action, Offset },
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Button extends Vue {
  @Prop()
  modelValue!: IFlexMessageButton

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageButton) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'ボタン',
        value: 'button',
      },
    ]
  }

  get marginList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  get trueFalseList() {
    return [
      {
        label: '',
        value: '',
      },
      {
        label: 'True',
        value: true,
      },
      {
        label: 'False',
        value: false,
      },
    ]
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  marginValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.marginList.includes(val)
    return !(!isPx && !isKeyword)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    if (this.value.action) {
      if (this.value.action.type === 'uri') {
        const uriAction: IFlexMessageURIAction = {
          type: 'uri',
          label: 'action',
          uri: 'http://linecorp.com/',
          altUri: {
            desktop: '',
          },
        }
        this.value.action = { ...uriAction, ...this.value.action }
      }
    }
    this.validate()
  }
}
